import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="loading-screen">
      <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
    </div>
  );
}

export function Protected({ role, children }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking || user === null) return <LoadingScreen />;
  if (!user) return <Navigate to="/flashcards" state={{ from: location }} replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/flashcards/admin" : "/flashcards/dashboard"} replace />;
  }
  return children;
}
